import React, { memo } from 'react';
import { Text, View, Image } from 'react-native';
import { COLOR, FONT, FONT_SIZE, THEME, THEME_DARK, __WEB__ } from '../../constants/styles';
import {
  OPComponent,
  CTAButton,
  I18n,
  Utils,
  NavBar,
  Container,
  FormInput,
  FormHelpers,
} from '../components';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { requestSecurityEmail, resetStatus, setScreenState } from './actions';

import { styles, Header } from './common_ui';

import { PENDING, REQUESTING, SUCCESS, FAILED } from '../../actions/statusTypes';

const REFS = {};

class PartAIntro extends OPComponent {
  constructor(props) {
    super(props);

    this.state = {
      securityEmail: '',
      fieldsValid: false,
      agreedToTerms: false,
      viewedInstructions: false,
    };
  }
  componentDidMount() {
    let fieldsValid = FormHelpers.validateFields(Object.values(REFS));
    this.setState({ fieldsValid });
  }
  componentWillUnmount() {}

  componentDidUpdate(prevProps, prevState) {
    if (this.state.securityEmail !== prevState.securityEmail) {
      let fieldsValid = FormHelpers.validateFields(Object.values(REFS));
      this.setState({ fieldsValid });
    }
    if (this.state.agreedToTerms !== prevState.agreedToTerms) {
      let fieldsValid = FormHelpers.validateFields(Object.values(REFS));
      this.setState({ fieldsValid });
    }
  }

  submitEmail = () => {
    const props = this.props;
    props.actions.requestSecurityEmail(this.state.securityEmail, props.mode);
  };

  agreeToTerms = () => {
    this.setState({ agreedToTerms: true });
  };
  viewIntructions = () => {
    this.props.actions.resetStatus();
    this.setState({ viewedInstructions: true });
  };
  previous = () => {
    if (!!this.state.agreedToTerms) {
      this.setState({ agreedToTerms: false });
    } else if (!!this.state.viewedInstructions) {
      this.setState({ viewedInstructions: false });
    } else {
      this.props.actions.setScreenState({ partAStarted: false });
    }
  };

  nextLabel() {
    return 'Next';
  }

  handleChangeSecurityEmail = (securityEmail) => {
    this.setState({ securityEmail });
  };

  renderEmailSent() {
    const props = this.props;
    if (!props.emailRequested) return null;

    return (
      <View style={styles.sectionContainer}>
        <Text style={styles.sectionLabel}>Security Email</Text>
        <View style={styles.section}>
          <View style={{ alignItems: 'center', paddingTop: 50 }}>
            <Image
              style={[styles.emailSentIcon]}
              source={require('../../../resources/icon-email-sent.png')}
              resizeMode="contain"
            />
            <Text style={[THEME.textMedium, { fontSize: 14, marginTop: 30 }]}>
              Confirmation Email Sent
            </Text>
          </View>
          <Text style={[styles.questionLabel, { marginTop: 40 }]}>
            Please follow the instructions in the email to resume your Part A.
          </Text>
        </View>
      </View>
    );
  }

  renderSecurityScreen() {
    const props = this.props;
    // return null;
    if (
      props.emailRequested ||
      (!props.oneUseToken && (!this.state.viewedInstructions || !this.state.agreedToTerms))
    )
      return null;
    const desc =
      "A security email helps verify your identity and will let you re-access your <b>saved</b> PHA if you encounter a technical issue or can't complete PHA Part A in one go. <br></br>Please only enter an email accessible from this device. You will receive an email with a link to continue the form.";
    return (
      <>
        <View style={[styles.sectionContainer, __WEB__ ? null : { flex: 1, overflowY: 'scroll' }]}>
          <Text style={styles.sectionLabel}>Security Email</Text>
          <View style={styles.section}>
            <Text style={styles.questionLabel}>
              <div dangerouslySetInnerHTML={{ __html: desc }} />
            </Text>
            <FormInput
              ref={(ref) => {
                REFS['securityEmail'] = ref;
              }}
              required={true}
              controlled={false}
              value={this.state.securityEmail}
              label={'security email'}
              onChangeText={this.handleChangeSecurityEmail}
              onSubmitEditing={null}
              validateFunc={Utils.validate.email}
              autoCapitalize={'none'}
              autoCorrect={false}
            />
          </View>
        </View>
        <View style={[THEME.basicRow]}>
          <CTAButton
            disabled={!this.state.fieldsValid || props.status === REQUESTING}
            onPress={this.submitEmail}
            label={this.nextLabel()}
            style={{ flex: 1, marginTop: 4, marginHorizontal: 20, marginBottom: 30 }}
          />
        </View>
      </>
    );
  }

  renderInstructions() {
    const props = this.props;
    // return null;
    if (props.oneUseToken || props.emailRequested || this.state.viewedInstructions) return null;

    const desc =
      'You are highly encouraged to answer all questions. If you do not understand a question, please discuss the question with a health care provider. If this is your first PHA since entering the United States military (or if you don’t know if you’ve ever had a PHA) ONLY consider the <b>PAST 12 MONTHS</b> when responding to the questions below that say “since your last PHA”.';

    return (
      <>
        <View style={[styles.sectionContainer]}>
          <Text style={styles.sectionLabel}>Instructions</Text>
          <View style={[styles.section]}>
            <Text style={styles.questionLabel}>
              <div dangerouslySetInnerHTML={{ __html: desc }} />
            </Text>
          </View>
        </View>
        <View style={[THEME.basicRow, { marginTop: 40 }]}>
          <CTAButton
            disabled={!this.state.fieldsValid}
            onPress={this.viewIntructions}
            label={this.nextLabel()}
            style={{ flex: 1, marginTop: 4, marginHorizontal: 20, marginBottom: 30 }}
          />
        </View>
      </>
    );
  }

  renderTerms() {
    const props = this.props;
    // return null;
    if (
      props.oneUseToken ||
      props.emailRequested ||
      this.state.agreedToTerms ||
      !this.state.viewedInstructions
    )
      return null;

    const privacyStatement =
      'DD Form 3024 will collect PII that is stored in active duty or reserve service members’ medical and military personnel records, a system of records, and retrieved by a personal identifier. Therefore, the Privacy Act applies, and a Privacy Act statement is required. The attached updated Privacy Act statement should be provided to individuals prior to their completing or being asked for any of the information requested by DD Form 3024. This updated Privacy Act Statement is needed to ensure the proper SORN is fully cited, the legal authorities are updated to the proper authorities, and the citation to DoD’s Blanket Routine Uses of Information is removed because those uses are no longer applicable. This statement serves to inform you of the purpose for collecting personal information as required by DD Form 3024, Annual Periodic Health Assessment, and how the information will be used.<br></br><b>Authorities</b>: 10 U.S.C., Chapter Ch. 55, Medical and Dental Care; DoDI 6200.06, “Periodic Health Assessment Program”<br></br><b>Purpose</b>: To periodically assess the health and well-being of active duty and reserve military servicemembers regarding force readiness and servicemembers’ suitability for deployment. Information collected will be used to assess force readiness and recommend proactive health interventions for individuals.<br></br><b>Routine Uses</b>: Information in your records may be disclosed to personnel within the Defense Health Agency and Department of Defense for the purposes of documenting the current state of your health and well-being, assessing your suitability for deployment, and recommending proactive health intervention. Any protected health information (PHI), including mental health and substance abuse information, in your records may be used and disclosed generally as permitted by the HIPAA rules (45 CFR Parts 160 and 164), as implemented by DoD. Permitted uses and disclosures of PHI include, but are not limited to, treatment, payment, and healthcare operations.<br></br><b>Applicable SORN</b>: EDHA 07, “Military Health Information System” (June 15, 2020, 85 FR 36190) <a href="https://dpcld.defense.gov/Portals/49/DocumentsPrivacy/SORNs/DHA/EDHA-07.pdf" target="_blank" />';

    return (
      <>
        <View style={[styles.sectionContainer]}>
          <Text style={styles.sectionLabel}>PRIVACY STATEMENT</Text>
          <View style={[styles.section]}>
            <Text style={[styles.questionLabel]}>
              <div dangerouslySetInnerHTML={{ __html: privacyStatement }} />
            </Text>
          </View>
        </View>
        <View style={[THEME.basicRow, { marginTop: 40 }]}>
          <CTAButton
            disabled={!this.state.fieldsValid}
            onPress={this.agreeToTerms}
            label={this.nextLabel()}
            style={{ flex: 1, marginTop: 4, marginHorizontal: 20, marginBottom: 30 }}
          />
        </View>
      </>
    );
  }

  render() {
    const props = this.props;
    const isVerticalLayout = this.props.isVerticalLayout;
    //valid=true;
    let valid = this.state.fieldsValid;

    return (
      <View style={styles.container}>
        <View style={styles.innerContainer}>
          <Header onPressPrevious={this.previous} label="Annual Periodic Health Assessment" />
          <Container
            renderActivityOverlay={props.status === REQUESTING}
            scrollView={true}
            errorMessage={
              props.errorMessage
                ? props.errorMessage?.message || 'unknown error, please try again'
                : ''
            }
          >
            {this.renderInstructions()}
            {this.renderTerms()}
            {this.renderSecurityScreen()}
            {this.renderEmailSent()}
          </Container>
        </View>
      </View>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    status: state.screens.partA.status,
    errorMessage: state.screens.partA.errorMessage,
    emailRequested: state.screens.partA.emailRequested,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        requestSecurityEmail,
        resetStatus,
        setScreenState,
      },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PartAIntro);
